import React from 'react';
import "./Traffic.css";
import AutoIcon from "../../controls/AutoIcon.mjs";
import TextLabel from "../../controls/TextLabel.mjs";
import Glob from "../../libs/Glob.mjs";
import appLib from "../../libs/appLib.mjs";
import {Button} from "reactstrap";
import openLocationInNavigator from "../../controls/openLocationInNavigator.mjs";
import SunsetIcon from "../../media/assets/SunsetIcon.mjs";

const timeParam = d => ({value:d.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'}).replace(/^0/,'')});

//const timeOnly = d => d.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'}).replace(/^0/,'');

const dateString = (d = (new Date())) => (new Date(d - d.getTimezoneOffset()*60000)).toISOString().replace(/T.*/,'');
const dateTomorrowString =  () => dateString(new Date((new Date()).setDate((new Date()).getDate()+1)));

const Traffic = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			lang: Glob.getLanguage(),
			updated: Glob.getStatus('appPulse')
		};
		this.uid = Glob.generateUid('Traffic');
		this.load = this.load.bind(this);
		this.mapTo = this.mapTo.bind(this);
		this.getSunriseSunset = this.getSunriseSunset.bind(this);
		this.glanceBox = this.glanceBox.bind(this);
	}
	componentDidMount() {
		Glob.register('Prefs', ()=>{
			const l = Glob.getLanguage();
			if ( l !== this.state.lang ) {
				this.loading = false;
				this.setState({ lang: l, loaded: false }, this.load);
			}
		}, this.uid);
		Glob.register('appPulse', p => {
			this.setState({ updated: p });
		}, this.uid);
		setTimeout( this.load );
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
	}
	async mapTo() {
		if ( ! this.state.coords ) return;
		const [lon,lat] = this.state.coords;
		console.log( await openLocationInNavigator(lat,lon) );
	}
	async load() {
		if ( this.state.loaded || this.loading) return;
		this.loading = true;
		if ( this.timeout ) {
			try {
				clearTimeout( this.timeout );
			} catch ( e ) {}
			this.timeout = false;
		}
		let coords = false;
		let data;
		try {
			data = await appLib.data('meteo');
			coords = [data.lon,data.lat];
		} catch (e) {
			console.error(e);
			this.timeout = setTimeout( ()=>{ this.setState({ loaded: false }, this.load); }, 3000);
		}
		this.setState({ loaded: true, data: data.meteo, coords: coords, updated: (new Date()).getTime() }, ()=>{
			this.loading = false;
		});
	}
	getSunriseSunset( updatedTime = (new Date()).getTime() ) {
		if ( ! this.state.data ) return '';
		if ( ! Array.isArray( this.state.data ) ) return '';
		const now = new Date(updatedTime);
		const todayString = dateString(now);
		const tomorrowString = dateTomorrowString();
		const today = Glob.clone(this.state.data.find( d => d.day === todayString ));
		const tomorrow = Glob.clone(this.state.data.find( d => d.day === tomorrowString ));
		if ( ! ( today?.sunrise && tomorrow?.sunrise  && today?.sunset && tomorrow?.sunset) ) return '';
		today.sunrise = new Date( todayString + ' ' + today.sunrise + ':00');
		today.sunset = new Date( todayString + ' ' + today.sunset + ':00');
		tomorrow.sunrise = new Date( tomorrowString + ' ' + tomorrow.sunrise + ':00');
		tomorrow.sunset = new Date( tomorrowString + ' ' + tomorrow.sunset + ':00');
		if ( now >= today.sunset ) return(
			<div className={"SunriseSunset"}>
				<h3 className={"sunrise"}>
					<div><SunsetIcon /></div>
					<span><TextLabel value={"SunriseAt"} params={ timeParam(tomorrow.sunrise) } /></span>
				</h3>
				<h3 className={"sunset"}>
					<div><SunsetIcon /></div>
					<span><TextLabel value={"SunsetAt"} params={ timeParam(tomorrow.sunset) } /></span>
				</h3>
			</div>
		);
		if ( now >= today.sunrise ) return(
			<div className={"SunriseSunset"}>
				<h3 className={"sunset"}>
					<div><SunsetIcon /></div>
					<span><TextLabel value={"SunsetAt"} params={ timeParam(today.sunset) } /></span>
				</h3>
				<h3 className={"sunrise"}>
					<div><SunsetIcon /></div>
					<span><TextLabel value={"SunriseAt"} params={ timeParam(tomorrow.sunrise) } /></span>
				</h3>
			</div>
		);
		return (
			<div className={"SunriseSunset"}>
				<h3 className={"sunrise"}>
					<div><SunsetIcon /></div>
					<span><TextLabel value={"SunriseAt"} params={ timeParam(today.sunrise) } /></span>
				</h3>
				<h3 className={"sunset"}>
					<div><SunsetIcon /></div>
					<span><TextLabel value={"SunsetAt"} params={ timeParam(today.sunset) } /></span>
				</h3>
			</div>
		);
	}
	glanceBox() {
		if ( ! this.state.data ) return '';
		if ( ! Array.isArray( this.state.data ) ) return '';
		const now = new Date();
		const todayString = dateString(now);
		const today = Glob.clone(this.state.data.find( d => d.day === todayString ));
		if ( ! Array.isArray( today?.hours ) ) return '';
		const hour = today.hours[now.getHours()];
		if ( ! hour ) return '';
		const nextHour = (() => {
			let nh = today.hours[now.getHours() +1];
			if ( nh ) return nh;
			const tomorrowString = dateTomorrowString();
			const tomorrow = Glob.clone(this.state.data.find( d => d.day === tomorrowString ));
			if ( ! Array.isArray( tomorrow.hours ) ) return '';
			return tomorrow.hours[0];
		})();
		if ( ! nextHour ) return '';
		const curMinute = now.getMinutes();
		const tbVal = ( cv, nv, decs = 0) => {
			if ( ! curMinute ) return cv;
			const av = cv + curMinute * ( nv - cv ) / 60;
			if ( ! decs ) return Math.round( av );
			return Math.round( av * ( 10 ** decs ) ) / (10 ** decs );
		}
		const div = ( label, value, unit="%" ) => (
			<div>
				<label><TextLabel value={label} /></label>
				{ value ? <><strong>{ value }</strong><span>{unit}</span></> : <span>— —</span>}
			</div>
		);
		return(
			<div className={"MeteoGlanceBox"}>
				<p>{ (new Date()).toLocaleTimeString().replace(/^0?(.+):..$/,"$1") }</p>
				<div>
					<label><TextLabel value={"Temperature"} /></label>
					<strong>{ tbVal(hour.temp,nextHour.temp,1) }</strong>
					<span>°C</span>
				</div>
				<div>
					<label><TextLabel value={"Perceived"} /></label>
					<strong>{ tbVal(hour.app, nextHour.app, 1) }</strong>
					<span>°C</span>
				</div>
				{ div('Rain', tbVal(hour.pp,nextHour.pp) ) }
				{ div('Humidity', tbVal(hour.hum,nextHour.hum) ) }
				{ div('Wind', tbVal(hour.wind, nextHour.wind), 'Km/h') }
			</div>
		);
	}
	render() {
		if ( ! this.state.loaded ) return '';
		return(
			<div className={"Traffic"} id={this.uid}>
				{ this.state.coords && (
					<p
						className={"navButton"}
						style={{textAlign:"center", margin:".5rem 0",padding:"0 0 0 0"}}
					>
						<Button
							color={"success"}
							onClick={ this.mapTo }
						>
							<b>
								<TextLabel value={"Drive directions"} />
							</b>
							<i>
								<AutoIcon value={"traffic"} />
							</i>
						</Button>
					</p>
				)}
				{ this.getSunriseSunset( this.state.updated ) }
				{ this.glanceBox( this.state.updated ) }
			</div>
		)
	}
}

export default Traffic;